/* Modules */
import LegCountyFactsSlider from './modules/LegCountyFactsSlider';
import LegCountySelectFacts from './modules/LegCountySelectFacts';
import LegDashTestimonialShowMore from './modules/LegDashTestimonialShowMore';
import LegMoveProfile from './modules/LegMoveProfile';
import LegDashTabs from './modules/LegDashTabs';
import LegTourismSlider from './modules/LegTourismSlider';
import LegDashGrantsModal from './modules/LegDashGrantsModal';

document.addEventListener('DOMContentLoaded', () => {
  const legCountyFactsSliders = document.querySelectorAll(
    '.js-county-fact-slider'
  );
  if (legCountyFactsSliders.length > 0) {
    legCountyFactsSliders.forEach((slider) => {
      new LegCountyFactsSlider(slider);
    });
  }

  const legCountySelectFacts = document.querySelector('.js-leg-county-select');
  if (legCountySelectFacts) {
    new LegCountySelectFacts(legCountySelectFacts);
  }

  const legDashTestimonialShowMoreBtns = document.querySelectorAll(
    '.js-testimonial-show-more'
  );

  if (legDashTestimonialShowMoreBtns.length > 0) {
    legDashTestimonialShowMoreBtns.forEach((btn) => {
      new LegDashTestimonialShowMore(btn);
    });
  }

  const legMoveProfile = document.querySelector('.js-leg-profile-container');
  if (legMoveProfile) {
    new LegMoveProfile(legMoveProfile);
  }

  const legDashTabs = document.querySelector('.leg-dash-tabs');
  if (legDashTabs) {
    new LegDashTabs(legDashTabs);
  }

  const legTourismSlider = document.querySelector('.js-leg-tourism-slider');
  if (legTourismSlider) {
    new LegTourismSlider(legTourismSlider);
  }

  const legDashGrantsModals = document.querySelectorAll('.js-leg-grant-modal');
  if (legDashGrantsModals.length > 0) {
    legDashGrantsModals.forEach((modal) => new LegDashGrantsModal(modal));
  }
});
